if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();


        if (!this.hasAttribute('available')) return;

        const sectionStock = this.closest('[id^="Section-"].hidden')
        if(sectionStock) sectionStock.classList.remove('hidden');

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        const useRedesignAvailability = this.dataset.useRedesignAvailability === 'true';
        const sectionId = useRedesignAvailability ? 'pickup-availability-custom' : 'pickup-availability';
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=${sectionId}`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            if (useRedesignAvailability) {
                this.renderPreviewCustom(sectionInnerHTML);
            } else {
                this.renderPreview(sectionInnerHTML);
            }
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
      }

      renderPreviewCustom(sectionInnerHTML) {
        this.innerHTML = sectionInnerHTML.outerHTML;
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          console.log('here');
          this.removeAttribute('available');
          return;
        }
        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
        const cityNames = this.querySelectorAll('p.caption-large span')
        const sliderComponent = this.nextElementSibling.nextElementSibling
        const blocks = sliderComponent.querySelectorAll('li.slider__slide--block');

        if(cityNames && blocks) {
            let countStores = 0;
            [...cityNames].forEach((city) => {
                const cityName = city.textContent;
                [...blocks].forEach(blockCity => {
                    const blockCityName = blockCity.dataset.locationMatch;
                    if (blockCityName == cityName) {
                        blockCity.classList.remove('hidden');
                        countStores++;
                    } else {
                        blockCity.remove();
                    }
                });
            });
            this.classList.add('hidden')
            const newStores = sliderComponent.querySelectorAll('li.slider__slide--block .stock-item');
            switch (countStores) {
                case 1:
                    break;
                case 2:
                    newStores[0].classList.add('has-border')
                    break;

                case 3:
                    newStores[0].classList.add('has-border')
                    newStores[1].classList.add('has-border')
                    break;

                case 4:
                    newStores[0].classList.add('has-border')
                    newStores[1].classList.add('has-border')
                    break;

                case 5:
                    newStores[0].classList.add('has-border')
                    newStores[1].classList.add('has-border')
                    newStores[3].classList.add('has-border')
                    break;

                case 6:
                    newStores[0].classList.add('has-border')
                    newStores[1].classList.add('has-border')
                    newStores[3].classList.add('has-border')
                    newStores[4].classList.add('has-border')
                    break;

                default:
                    break;
            }
        }

        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));

        const button = this.querySelector('button');
        if (button)
          button.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer').show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
